export default {
      id: "volume-1st-party-usage",
      viewBox: "0 0 43 31",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#volume-1st-party",
      toString: function () {
        return this.url;
      }
    }